module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("蓝图")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择考试类型"
    },
    model: {
      value: (_vm.queryParam.examType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examType", $$v)
      },
      expression: "queryParam.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/blueprints/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.form.id ? '编辑蓝图' : '新建蓝图',
      "width": "980"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.onExamTypeChange
    },
    model: {
      value: (_vm.form.examType),
      callback: function($$v) {
        _vm.$set(_vm.form, "examType", $$v)
      },
      expression: "form.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": _vm.form.examType === 'SUMMATIVE' ? '技能站点' : '档位'
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.segment),
      callback: function($$v) {
        _vm.$set(_vm.form, "segment", $$v)
      },
      expression: "form.segment"
    }
  }, _vm._l((_vm.segmentOptions(_vm.form.examType, _vm.form.segment)), function(s) {
    return _c('Option', {
      key: s.value,
      attrs: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "版本"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "v1.0"
    },
    model: {
      value: (_vm.form.versionNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "versionNo", $$v)
      },
      expression: "form.versionNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题量上限"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 200,
      "placeholder": "0 表示沿用默认"
    },
    model: {
      value: (_vm.form.itemLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "itemLimit", $$v)
      },
      expression: "form.itemLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "限时（秒）"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 7200,
      "placeholder": "0 表示沿用默认"
    },
    model: {
      value: (_vm.form.durationSec),
      callback: function($$v) {
        _vm.$set(_vm.form, "durationSec", $$v)
      },
      expression: "form.durationSec"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "组卷槽位"
    }
  }, [_c('p', {
    staticClass: "mex-slot-hint"
  }, [_vm._v("每一行是一类题：从哪个库抽、什么技能和题型、出几道、每道多少分。入门测不能加写作。")]), _vm._v(" "), _vm._l((_vm.slots), function(slot, idx) {
    return _c('div', {
      key: idx,
      staticClass: "mex-slot-card"
    }, [_c('div', {
      staticClass: "mex-slot-head"
    }, [_c('span', [_vm._v("第 " + _vm._s(idx + 1) + " 类题")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeSlot(idx)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('Form', {
      attrs: {
        "show-message": false,
        "label-position": "top"
      }
    }, [_c('Row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "题库"
      }
    }, [_c('Select', {
      attrs: {
        "transfer": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.onBankChange(slot)
        }
      },
      model: {
        value: (slot.bank),
        callback: function($$v) {
          _vm.$set(slot, "bank", $$v)
        },
        expression: "slot.bank"
      }
    }, [_c('Option', {
      attrs: {
        "value": "COMP"
      }
    }, [_vm._v("综合库（听/读/写）")]), _vm._v(" "), _c('Option', {
      attrs: {
        "value": "SPEAK"
      }
    }, [_vm._v("口语库")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "技能"
      }
    }, [_c('Select', {
      attrs: {
        "transfer": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.onSkillChange(slot)
        }
      },
      model: {
        value: (slot.skill),
        callback: function($$v) {
          _vm.$set(slot, "skill", $$v)
        },
        expression: "slot.skill"
      }
    }, [_c('Option', {
      attrs: {
        "value": "Listening"
      }
    }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
      attrs: {
        "value": "Speaking"
      }
    }, [_vm._v("口语 Speaking")]), _vm._v(" "), _c('Option', {
      attrs: {
        "value": "Reading"
      }
    }, [_vm._v("阅读 Reading")]), _vm._v(" "), (_vm.form.examType !== 'PLACEMENT') ? _c('Option', {
      attrs: {
        "value": "Writing"
      }
    }, [_vm._v("写作 Writing")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "题型"
      }
    }, [_c('Select', {
      attrs: {
        "filterable": "",
        "transfer": "",
        "placeholder": "与题库列表题型一致"
      },
      model: {
        value: (slot.questionType),
        callback: function($$v) {
          _vm.$set(slot, "questionType", $$v)
        },
        expression: "slot.questionType"
      }
    }, _vm._l((_vm.questionTypesOf(slot.skill, slot.questionType)), function(t) {
      return _c('Option', {
        key: t.value,
        attrs: {
          "value": t.value
        }
      }, [_vm._v(_vm._s(t.label))])
    }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "出几道"
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 1,
        "max": 20,
        "placeholder": "如 4"
      },
      model: {
        value: (slot.count),
        callback: function($$v) {
          _vm.$set(slot, "count", $$v)
        },
        expression: "slot.count"
      }
    })], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "每道分值"
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0,
        "max": 20,
        "step": 1,
        "placeholder": "如 1"
      },
      model: {
        value: (slot.scoreEach),
        callback: function($$v) {
          _vm.$set(slot, "scoreEach", $$v)
        },
        expression: "slot.scoreEach"
      }
    })], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "dashed",
      "long": ""
    },
    on: {
      "click": _vm.addSlot
    }
  }, [_vm._v("添加一类题")])], 2), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "模块权重"
    }
  }, [_c('p', {
    staticClass: "mex-slot-hint"
  }, [_vm._v("报告合成总分时按模块占比加权，不参与抽题。入门测只有听/说/读，建议合计 100。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-slot-card"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.weights), function(w) {
    return _c('i-col', {
      key: w.skill,
      attrs: {
        "span": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.skillLabel(w.skill)
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0,
        "max": 100,
        "placeholder": "百分数，如 40"
      },
      model: {
        value: (w.weight),
        callback: function($$v) {
          _vm.$set(w, "weight", $$v)
        },
        expression: "w.weight"
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-slot-hint"
  }, [_vm._v("当前合计 " + _vm._s(_vm.weightSum))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baeb48ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexBlueprintList.vue
// module id = 1957
// module chunks = 8